/**
 * Created by ChrisMuto on 7/18/17.
 */
export const DID_NAVIGATE = "Dashboard: navigated to the dashboard";

export const DID_SORT = "Dashboard: sorted the dashboard by a feature";
export const DID_SEARCH = "Dashboard: filtered the dashboard by search query";

export const DID_CLICK_CREATE_TEST = "Dashboard: clicked create test button";
export const DID_CLICK_EDIT_TEST = "Dashboard: clicked edit test";
export const DID_CLICK_VIEW_RESULTS = "Dashboard: clicked view test results";
export const DID_CLICK_VIEW_DETAILS = "Dashboard: clicked view test details";

export const DID_ARCHIVE_TEST = "Dashboard: archived a test";
export const DID_DELETE_TEST = "Dashboard: deleted a test";
export const DID_CLONE_TEST = "Dashboard: cloned a test";
export const DID_CHANGE_TABS = "Dashboard: changed tabs";



// WEBPACK FOOTER //
// ./src/modules/tracker/event-names/dashboard-events.js